import { colorCSS } from "../../styles";

export const X = ({ color }: { color?: string }) => {
    return (
        <svg
            fill="none"
            height="19"
            viewBox="0 0 21 19"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                stroke={color ? colorCSS(color) : "currentColor"}
                strokeLinecap="round"
                strokeWidth="3"
            >
                <path d="m3 16.8492 14.8492-14.84921" />
                <path d="m3.12132 2 14.84928 14.8492" />
            </g>
        </svg>
    );
};
